import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  styled,
} from "@mui/material";

const PrimarySelect = ({
  label,
  selectedValue,
  onChange,
  values,
  name,
  variant = "standard",
}) => {
  return (
    <CustomFormControl>
      {label && <CustomLabel id={`${label}-select-label`}>{label}</CustomLabel>}
      <CustomSelect
        labelId={`${label}-select-label`}
        id={`${label}-select`}
        value={selectedValue}
        label={label}
        onChange={onChange}
        name={name}
        variant={variant}
      >
        <CustomMenuItem value="">
          <em>None</em>
        </CustomMenuItem>
        {values.map(({ value, title }) => (
          <CustomMenuItem value={value} key={value}>
            {title}
          </CustomMenuItem>
        ))}
      </CustomSelect>
    </CustomFormControl>
  );
};

const CustomFormControl = styled(FormControl)(() => ({
  marginTop: "16px",
  width: "100%",
}));

const CustomLabel = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

const CustomSelect = styled(Select)(({ theme }) => ({
  color: theme.palette.primary.white,
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.secondary.white,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.main,
  },
  svg: {
    fill: theme.palette.secondary.main,
  },
}));

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.primary.white,
  "&:hover": {
    backgroundColor: "transparent",
    color: theme.palette.primary.hover,
  },
  "&.Mui-selected": {
    backgroundColor: "transparent !important",
    color: theme.palette.primary.main,
  },
  "&.Mui-selected:hover": {
    backgroundColor: "transparent",
    color: theme.palette.primary.hover,
  },
}));

export default PrimarySelect;
